import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'guatemalaTime',
  standalone: true,
})
export class GuatemalaTimePipe implements PipeTransform {
  private readonly guatemalaTimezone = 'America/Guatemala';

  transform(value: Date | string | null | undefined, format = 'short'): string {
    if (!value) return '';

    try {
      const date = new Date(value);
      if (isNaN(date.getTime())) return '';

      return formatDate(date, format, 'en-US', this.guatemalaTimezone);
    } catch {
      return '';
    }
  }
}
